import Admins from './components/Admins';

export default Admins;
